// extracted by mini-css-extract-plugin
export default {"dots":"Loader_dots__eRSc0","dot":"Loader_dot__KEi6-","pulse":"Loader_pulse__c-LVU"};